module.exports = __webpack_public_path__ + "media/sample-call.52da7806.mp3";